import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusIcon, EditIcon, EyeIcon } from 'lucide-react';
import { DataTable, Column } from '../components/DataTable';
import { StatusBadge } from '../components/StatusBadge';
import { mockReceives } from '../data/mockData';
import { ReceiveEntry } from '../types';
export function ReceiveList() {
  const navigate = useNavigate();
  const columns: Column<ReceiveEntry>[] = [{
    key: 'receiveNo',
    label: 'Receive No',
    render: r => <span className="font-medium text-indigo-600" data-id="element-1920">{r.receiveNo}</span>
  }, {
    key: 'linkedPONo',
    label: 'PO No'
  }, {
    key: 'vendor',
    label: 'Vendor'
  }, {
    key: 'receiveDate',
    label: 'Receive Date'
  }, {
    key: 'totalReceiveAmount',
    label: 'Total Amount',
    render: r => <span className="font-medium" data-id="element-1921">
          ${r.totalReceiveAmount.toLocaleString()}
        </span>
  }, {
    key: 'status',
    label: 'Status',
    render: r => <StatusBadge status={r.status} data-id="element-1922" />
  }, {
    key: 'createdBy',
    label: 'Created By'
  }];
  return <div className="space-y-6 h-full flex flex-col" data-id="element-1923">
      <div className="flex items-center justify-between" data-id="element-1924">
        <div data-id="element-1925">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-1926">
            Receive Management
          </h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-1927">
            Record and manage goods/services received.
          </p>
        </div>
        <button onClick={() => navigate('/receives/create')} className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700" data-id="element-1928">
          <PlusIcon className="h-4 w-4 mr-2" data-id="element-1929" />
          New Receive
        </button>
      </div>

      <div className="flex-1" data-id="element-1930">
        <DataTable columns={columns} data={mockReceives} keyExtractor={item => item.id} searchPlaceholder="Search receives..." onRowClick={item => {
        if (item.status !== 'Processed') {
          navigate(`/receives/${item.id}/edit`);
        }
      }} actions={item => <div className="flex space-x-3 justify-end" data-id="element-1932">
              {item.status === 'Processed' ? <button disabled className="text-gray-400 cursor-not-allowed opacity-50" title="Cannot edit processed receive" data-id="element-1933">
                  <EditIcon className="h-4 w-4" data-id="element-1934" />
                </button> : <button onClick={() => navigate(`/receives/${item.id}/edit`)} className="text-indigo-600 hover:text-indigo-900" data-id="element-1935">
                  <EditIcon className="h-4 w-4" data-id="element-1936" />
                </button>}
            </div>} data-id="element-1931" />
      </div>
    </div>;
}